module.exports = __webpack_public_path__ + "static/media/close.36f77d30.png";